// Internal dependencies
import { BASE_PATH_REGEX } from '../constants';

export const getBasePath = (pathname) => {
  const basePath = (pathname.match(BASE_PATH_REGEX) || [''])[0];
  return basePath;
};
